import React from 'react';
import { StaggeredMotion, spring } from 'react-motion';
// import { connect } from 'react-redux';

import { noop } from 'shared/helpers';
import { mixClasses as cx } from 'helpers';

import {
  BlogModuleBtn,
  AlbumModuleBtn,
  PlaylistModuleBtn,
} from './moduleChoiceBtns';


/*
 * CoreModulePickerRibbon
 *
 * References:
 * https://codepen.io/TylerK/pen/yOXJEV
 * http://chenglou.github.io/react-motion/demos/demo5-spring-parameters-chooser/
 */
const moduleBtnComponents = [
  BlogModuleBtn,
  AlbumModuleBtn,
  PlaylistModuleBtn,
];

const defaultStyle = { y: 8, o: 0 }; // y-position, opacity
const appliedStyle = { stiffness: 170, damping: 13 };

const interpolateStyles = (prevInterpolatedStyles) => (
  prevInterpolatedStyles.map((_, idx) => {
    return (
      idx === 0
      ? { y: spring(0, appliedStyle), o: spring(1) }
      : {
          y: spring(prevInterpolatedStyles[idx - 1].y, appliedStyle),
          o: spring(prevInterpolatedStyles[idx - 1].o)
        }
    );
  })
);


const CoreModulePickerRibbon = ({
  className,
  onSelect = noop,
}) => {
  return (
    <StaggeredMotion
      defaultStyles={moduleBtnComponents.map(() => defaultStyle)}
      styles={interpolateStyles}
    >
      {interpolatingStyles =>
        <div className={cx(
          'w-100 flex justify-center', className
        )}>
          {interpolatingStyles.map((style, idx) => {
            const ModuleBtnComponent = moduleBtnComponents[idx];
            const moduleBtnStyle = {
              transform: `translate3d(0, ${style.y}px, 0)`,
              opacity: style.o
            };

            return (
              <ModuleBtnComponent
                key={idx}
                onClick={onSelect}
                style={moduleBtnStyle}
              />
            );
          })}
        </div>
      }
    </StaggeredMotion>
  );
};



export default CoreModulePickerRibbon;



// WEBPACK FOOTER //
// ./src/components/modules/CoreModulePickerRibbon.js